import styled from 'styled-components'
// themes
import colors from 'themes/colors'

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Header = styled.div`
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.blue500};

  && {
    svg {
      top: 0;
      right: -12px;
    }
  }
`

export const ResultContent = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
`

export const ResultSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: black;
  padding: 8px;
  border: 1px solid lightgray;
  border-radius: 4px;
  background: #f2f2f2;
`

export const ResultSectionLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${colors.gray400};
`

export const ResultSectionValue = styled.div`
  font-size: 15px;
  line-height: 1.5;
  white-space: pre-wrap;
`

export const ResultExplanation = styled.div`
  font-size: 15px;
  line-height: 1.5;
`

export const ResultDisclaimer = styled.p`
  text-align: center;
  font-size: 12px;
  color: ${colors.gray380};
  margin: 12px 0 0;
`
